import {inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {resolveApiBase} from '../core/api-base';

interface StatusResponse {
  status: string;
}

// Story 28.3 — re-issue + resend a verification email. The backend
// (POST /resend-verification) is anti-enumeration: it always returns
// {"status":"ok"} regardless of whether the account/client exists.
@Injectable({providedIn: 'root'})
export class EmailVerificationService {
  private readonly http = inject(HttpClient);

  resendVerification(email: string, clientId: string): Observable<StatusResponse> {
    return this.http.post<StatusResponse>(
      `${resolveApiBase()}/resend-verification`,
      {email, client_id: clientId},
      {headers: new HttpHeaders({'Content-Type': 'application/json'}), withCredentials: true});
  }
}
